<template>
  <b-container class="login-container shadow">
    <b-row class="h-100 justify-content-center">
      <b-col lg="6" md="12" order-lg="1" order="2" class="quote-container px-0">
        <quote/>
      </b-col>
      <b-col lg="6" md="12" order-lg="2" order="1" class="form-wrapper">
        <a v-if="new Date() < new Date('2027-01-01')" href="https://energieagentur-sg.ch" target="_blank">
          <img src="~@/assets/img/energieagentur.svg" alt="Logo" class="logo logo-mobile">
        </a>
        <a v-if="new Date() >= new Date('2027-01-01')" href="https://energiekongress.ch/?utm_source=efoerderportal.sg.ch&utm_medium=banner&utm_campaign=energiekongress_2027" target="_blank">
          <img src="~@/assets/img/EASG_Energiekongress_2027_mobile_3.jpg" alt="Logo" class="banner-mobile mb-5 img-fluid">
        </a>
        <a v-if="new Date() >= new Date('2027-01-01')" href="https://energiekongress.ch/?utm_source=efoerderportal.sg.ch&utm_medium=banner&utm_campaign=energiekongress_2027" target="_blank">
          <img src="~@/assets/img/EASG_Energiekongress_2027_mobile.jpg" alt="Logo" class="banner-mobile-small mb-5 img-fluid">
        </a>
        <slot />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Quote from '@/components/login/Quote.vue'

  export default {
    components: {
      Quote
    }
  }
</script>

<style lang="scss">
  body{
    height: 100vh;
    background: $black-5;
  }
  .container{
    width: auto;
  }
  .login-container{
    background: $white;
    max-width: 1360px;
    margin-top: 5rem;

    @include media-breakpoint-down(md) {
        margin-top: 5rem;
    }

    @include media-breakpoint-down(md) {
        margin: 15px;
    }

    .quote-container{
      display: block;

      @include media-breakpoint-down(md) {
        display: none;
      }
    }

    .banner-mobile {
      display: none;

      @include media-breakpoint-down(md) {
        display: block;
      }

      @include media-breakpoint-down(sm) {
        display: none;
      }
    }

    .banner-mobile-small {
      display: none;

      @include media-breakpoint-down(sm) {
        display: block;
      }
    }

    .logo-mobile {
      display: none;
      max-width: 150px;
      margin: 0 auto 3rem;

      @include media-breakpoint-down(md) {
        display: block;
      }
    }
  }
  .form-wrapper{
    padding: 2rem 3rem 1rem;
    text-align: center;

    @include media-breakpoint-down(md) {
      padding: 3rem 1rem;
    }

    h1{
      &:not(:first-child) {
        margin-top: 3rem;
      }
      color: $black-80;
      font-size: $h2-font-size;
    }
    a{
      color: $black-40;
    }
    form{
      text-align: left;
      margin: 2rem auto .5rem;
    }
  }
</style>
